import { createSlice } from "@reduxjs/toolkit";
import { fetchVendorById, fetchVendorItems } from "./VendorThunks";

const initialState = {
  items: [],
  loading: false,
  loadingMore: false,
  error: null,
  single: null,
  status: "idle",
  currentPage: 1,
  hasMore: true,
  totalPages: 1,
  totalItems: 0,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    resetPagination: (state) => {
      state.items = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.totalPages = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorItems.pending, (state, action) => {
        const { reset } = action.meta.arg;
        if (reset) {
          state.loading = true;
          state.loadingMore = false;
        } else {
          state.loading = false;
          state.loadingMore = true;
        }
        state.error = null;
      })
      .addCase(fetchVendorItems.fulfilled, (state, action) => {
        state.loading = false;
        state.loadingMore = false;
        
        const { data, pagination, reset } = action.payload;
        
        if (reset) {
          state.items = data || [];
        } else {
          state.items = [...state.items, ...(data || [])];
        }
        
        if (pagination) {
          state.currentPage = pagination.currentPage || 1;
          state.totalPages = pagination.totalPages || 1;
          state.totalItems = pagination.totalItems || 0;
          state.hasMore = pagination.currentPage < pagination.totalPages;
        } else {
          state.hasMore = false;
        }
      })
      .addCase(fetchVendorItems.rejected, (state, action) => {
        state.loading = false;
        state.loadingMore = false;
        state.error = action.error.message;
      })

      // handle single vendor fetch
      .addCase(fetchVendorById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.single = action.payload;
      })
      .addCase(fetchVendorById.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { resetPagination } = vendorSlice.actions;
export default vendorSlice.reducer;